export default "__VITE_ASSET__D2gC$iyI__"